// Generated by Melange

import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(className) {
  return function (title) {
    return function (rightChildrenOpt) {
      const rightChildren = rightChildrenOpt !== undefined ? Caml_option.valFromOption(rightChildrenOpt) : null;
      return function (breadcrumb) {
        return function (route) {
          return function (arrowBackOpt) {
            const arrowBack = arrowBackOpt !== undefined ? arrowBackOpt : true;
            return JsxRuntime.jsxs("div", {
                        children: [
                          route !== undefined ? JsxRuntime.jsxs("div", {
                                  children: [
                                    arrowBack ? JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                            route: route,
                                            children: JsxRuntime.jsx("img", {
                                                  className: "w-5 h-5",
                                                  src: StaticAsset.src("/static/icons/arrow-back.svg")
                                                })
                                          }) : null,
                                    breadcrumb !== undefined ? JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                                            route: route,
                                            className: "flex gap-1",
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                                    className: "text-default-gray",
                                                    children: breadcrumb
                                                  }),
                                              JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                                    className: "text-default-gray",
                                                    children: "・"
                                                  })
                                            ]
                                          }) : null,
                                    title === "loading" ? JsxRuntime.jsx("div", {
                                            className: "bg-gray-pale w-40 h-6 rounded"
                                          }) : JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                            children: title
                                          })
                                  ],
                                  className: "flex items-center gap-2"
                                }) : JsxRuntime.jsxs("div", {
                                  children: [
                                    breadcrumb !== undefined ? JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                            className: "text-default-gray",
                                            children: breadcrumb
                                          }) : null,
                                    breadcrumb !== undefined ? JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                            className: "text-default-gray",
                                            children: "・"
                                          }) : null,
                                    title === "loading" ? JsxRuntime.jsx("div", {
                                            className: "bg-gray-pale w-40 h-6 rounded"
                                          }) : JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                            children: title
                                          })
                                  ],
                                  className: "flex gap-1"
                                }),
                          rightChildren
                        ],
                        className: Cn.fromList({
                              hd: "z-90 flex justify-between items-center border-gray-main border-b h-14 px-6",
                              tl: {
                                hd: Cn.take(className),
                                tl: /* [] */0
                              }
                            })
                      });
          };
        };
      };
    };
  };
}

function OrgDashboardHeader(Props) {
  return Curry._4(make(Props.className)(Props.title), Props.rightChildren, Props.breadcrumb, Props.route, Props.arrowBack);
}

const make$1 = OrgDashboardHeader;

export {
  make$1 as make,
}
/* Buhta_cabinet__Link Not a pure module */
